









import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class TabItem extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) active!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean;
}
